import React from 'react';
import Search from './Search';
import TooltipManagerInfoTab from './tooltipManagerInfo/TooltipManagerInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class TooltipManagerSetup extends React.Component {
    render() {
        let opts = {
            title: "Tooltip Manager Setup",
            description: "Create, modify, and remove tips",
            helpKey: Help.tooltipManagerSetupHelpKey,
			enableColumnSettings: true,
            recentType: "tooltipManager",
            list: {
                url: API.App.url('/tooltipManagerSetup/search'),
                rowKey: "tooltipCode",
                columns: [
                    { key: 'categoryTitle', name: 'Step', width: 250, sortable: true },
                    { key: 'title', name: 'Tooltip', sortable: true },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "tooltipManagerInfo", title: "Tooltip Manager Info", comp: TooltipManagerInfoTab, helpKey: Help.tooltipManagerSetupInfoHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.tooltipManagerSetupAuditHelpKey }
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default TooltipManagerSetup;


// WEBPACK FOOTER //
// ./src/areas/admin/tooltipManagerSetup/TooltipManagerSetup.js